<!-- Adapted from YesPlayMusic v0.4.11 (MIT), upstream SvgIcon.vue.
     Vite raw imports replace the upstream webpack SVG sprite loader. -->
<template>
  <svg :class="svgClass" :viewBox="icon.viewBox" aria-hidden="true" focusable="false" v-html="icon.body"></svg>
</template>

<script>
// These are bundled upstream SVG files; no remote or user HTML enters v-html.
const files = import.meta.glob('../assets/icons/*.svg', { query: '?raw', import: 'default', eager: true });
const icons = Object.fromEntries(Object.entries(files).map(([path, svg]) => {
  const name = path.split('/').pop().replace('.svg', '');
  return [name, {
    viewBox: svg.match(/viewBox="([^"]+)"/)?.[1] || '0 0 512 512',
    body: svg.replace(/^[\s\S]*?<svg\b[^>]*>/, '').replace(/<\/svg>\s*$/, ''),
  }];
}));

export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
  },
  computed: {
    icon() {
      return icons[this.iconClass] || { viewBox: '0 0 512 512', body: '' };
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    },
  },
};
</script>

<style scoped>
.svg-icon {
  fill: currentColor;
}
</style>
